"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractsSold = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_1 = __importDefault(require("moment"));
const app_1 = require("../../../../app");
const helpers_1 = require("../../../../utils/helpers");
const chart_view_1 = require("../../../../widgets/chart_view");
function createContractSoldChartOptions() {
    return {
        type: 'horizontalBar',
        data: {
            labels: [],
            datasets: [{
                    label: 'Forfaits',
                    data: [],
                    backgroundColor: [
                        chart_view_1.chartColors.green,
                        chart_view_1.chartColors.blue,
                        chart_view_1.chartColors.purple,
                        chart_view_1.chartColors.red
                    ]
                }]
        },
        options: {
            aspectRatio: (0, helpers_1.responsiveValues)(1, 2.5),
            maintainAspectRatio: true,
            responsive: true,
            title: {
                display: true,
                text: 'Forfaits vendus'
            },
            scales: {
                xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
            }
        }
    };
}
const ContractsSold = function () {
    return {
        loaded: false,
        options: createContractSoldChartOptions(),
        period: 'day',
        periodStart: (0, moment_1.default)().format("YYYY-MM-01"),
        refresh(period, periodStart) {
            this.period = period;
            this.periodStart = periodStart;
            return this.getData();
        },
        getData() {
            return app_1.App
                .get(`/stats/contracts_sold?period=${this.period}&period_start=${this.periodStart}`)
                .then((items) => {
                let o = this.options;
                o.data.labels = items.labels;
                o.data.datasets[0].data = items.values;
                mithril_1.default.redraw();
            });
        }
    };
};
exports.ContractsSold = ContractsSold;
